import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
import { GoogleTranslateWidget } from '../../../../components/GoogleTranslateWidget';
export function BlogPost7SignsGaslightingJA() {
  const articleData = {
    title: 'AIが即座に検知するガスライティングの7つの兆候',
    description: 'AIが即座に検知するガスライティングの7つの兆候を発見してください。テキストをアップロードして、操作、否定、感情的虐待のパターンを数秒で検出します。',
    slug: '7-signs-of-gaslighting',
    publishDate: '2025-01-14',
    author: 'Toxic Detector 編集部'
  };
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/blog/7-signs-of-gaslighting'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/blog/7-signs-of-gaslighting'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/blog/7-signs-of-gaslighting'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/blog/7-signs-of-gaslighting'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/blog/7-signs-of-gaslighting'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/blog/7-signs-of-gaslighting'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/blog/7-signs-of-gaslighting'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/blog/7-signs-of-gaslighting'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/blog/7-signs-of-gaslighting'
  }];
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: window.location.href
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('リンクがクリップボードにコピーされました！');
    }
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: '人間関係におけるガスライティングの初期兆候は何ですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '初期の兆候には、出来事の否定、事実の歪曲、感情の軽視、責任転嫁などがあります。これらのパターンは徐々にあなた自身の認識を疑わせるようになります。'
      }
    }, {
      '@type': 'Question',
      name: 'ガスライティングは本当にテキストメッセージで起こり得ますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'はい。テキストによるガスライティングは非常に一般的です。メッセージは操作的であったり、事実を歪めたり、罪悪感を抱かせたりする可能性があります。当社のAIはチャット履歴からこれらのパターンを即座に検出します。'
      }
    }, {
      '@type': 'Question',
      name: 'Toxic DetectorのAIはどのようにガスライティングのパターンを識別しますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Toxic Detectorは、トーンの変化、矛盾、非難のパターン、感情の軽視、罪悪感を誘発する言葉、公的および私的な行動の違いを分析します。'
      }
    }, {
      '@type': 'Question',
      name: 'ガスライティングと通常の意見の不一致の違いは何ですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '通常の意見の不一致には2つの視点が含まれます。ガスライティングには、あなたの現実を歪めたり、感情を無効にしたり、正気を疑わせたりするための意図的または繰り返しの試みが含まれます。'
      }
    }, {
      '@type': 'Question',
      name: 'なぜ人は人間関係でガスライティングを行うのですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'ガスライターはしばしばコントロールを望み、責任を回避し、またはパートナーの感情を操作します。多くの人は害を認識せずに学習したパターンを繰り返します。'
      }
    }, {
      '@type': 'Question',
      name: 'ガスライティングは意図的でない場合がありますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'はい、一部の人は気づかずにガスライティングを行います。この行動は、不安、回避、または学習された有毒なコミュニケーション習慣から生じる可能性があります。'
      }
    }, {
      '@type': 'Question',
      name: 'パートナーが私をガスライティングしていると思う場合はどうすればよいですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '直感を信じ、会話を記録し、信頼できる人と話し、専門的な視点を得ることを検討してください。Toxic Detectorのようなツールはパターンの確認に役立ちます。'
      }
    }, {
      '@type': 'Question',
      name: 'ガスライティングは感情的虐待の一形態ですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'はい。ガスライティングは、人の現実認識を操作するため、心理的および感情的虐待の一形態として認識されています。'
      }
    }, {
      '@type': 'Question',
      name: 'Toxic Detectorは操作の発見にどのくらい正確ですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '当社のAIは、メッセージ全体にわたる言語的、トーン的、行動的パターンを高精度で分析します。一貫した行動分析に裏打ちされた、明確で共有可能なレポートを提供します。'
      }
    }, {
      '@type': 'Question',
      name: 'ガスライティングは時間の経過とともに悪化しますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'ガスライティングはしばしば徐々にエスカレートします。被害者がより混乱したり依存したりするにつれて、操作者はコントロールを強め、感情的な圧力を強めます。'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/89an98a4aCmEYGiFGxbV6q/1763120076017.jpg',
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    }
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-7372">
      <GoogleTranslateWidget data-id="element-7373" />
      <Helmet data-id="element-7374">
        <title data-id="element-7375">
          ガスライティングの7つの兆候（AI検知）— 操作を素早く止める |
          ToxicDetector
        </title>
        <meta name="description" content="誰かがあなたをガスライティングしていると思いますか？当社のAIはチャットを分析することで、即座にトップ7の兆候を明らかにします。" data-id="element-7376" />
        <meta name="keywords" content="ガスライティングの兆候, ガスライティングの例, テキストメッセージでのガスライティング, 操作的な行動, AIガスライティング検出器" data-id="element-7377" />
        <meta name="language" content="ja" data-id="element-7378" />
        <link rel="canonical" href="https://toxicdetector.com/ja/blog/7-signs-of-gaslighting" data-id="element-7379" />
        {alternateUrls.map(alternate => <link key={alternate.lang} rel="alternate" hrefLang={alternate.lang} href={alternate.url} data-id="element-7380" />)}
        <meta property="og:type" content="article" data-id="element-7381" />
        <meta property="og:title" content="AIが即座に検知するガスライティングの7つの兆候" data-id="element-7382" />
        <meta property="og:description" content="誰かがあなたをガスライティングしていると思いますか？当社のAIはチャットを分析することで、即座にトップ7の兆候を明らかにします。" data-id="element-7383" />
        <meta property="og:url" content="https://toxicdetector.com/ja/blog/7-signs-of-gaslighting" data-id="element-7384" />
        <meta property="og:image" content="https://cdn.magicpatterns.com/uploads/9AgsYP8bczHQvssTJAPniL/file_00000000842c7243a7657dadb3d089c4.png" data-id="element-7385" />
        <meta property="og:locale" content="ja_JP" data-id="element-7386" />
        <meta name="twitter:card" content="summary_large_image" data-id="element-7387" />
        <meta name="twitter:title" content="ガスライティングの7つの兆候（AI検知）" data-id="element-7388" />
        <meta name="twitter:description" content="当社のAIはチャットを分析することで、ガスライティングのトップ7の兆候を即座に明らかにします。" data-id="element-7389" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/89an98a4aCmEYGiFGxbV6q/1763120076017.jpg" data-id="element-7390" />
        <script type="application/ld+json" data-id="element-7391">
          {JSON.stringify(articleSchema)}
        </script>
        <script type="application/ld+json" data-id="element-7392">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-7393">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-7394">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-7395">
            <div className="flex items-center justify-between" data-id="element-7396">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-7397">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="記事を共有" data-id="element-7398">
                <Share2 size={20} className="text-gray-600" data-id="element-7399" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-7400">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-7401">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-7402" />
            ブログに戻る
          </Link>

          <header className="mb-12" data-id="element-7403">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-7404">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-7405">
              <time dateTime={articleData.publishDate} data-id="element-7406">
                {new Date(articleData.publishDate).toLocaleDateString('ja-JP', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-7407">•</span>
              <span data-id="element-7408">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-7409">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/89an98a4aCmEYGiFGxbV6q/1763120076017.jpg" alt="AIが人間関係のテキストでガスライティングの兆候を検出" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-7410" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-7411">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-7412">目次</h2>
            <ul className="space-y-3 text-sm" data-id="element-7413">
              <li data-id="element-7414">
                <a href="#denying" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7415">
                  <span className="text-gray-400" data-id="element-7416">→</span> 1.
                  起きたことを否定する
                </a>
              </li>
              <li data-id="element-7417">
                <a href="#twisting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7418">
                  <span className="text-gray-400" data-id="element-7419">→</span> 2. 事実を歪める
                </a>
              </li>
              <li data-id="element-7420">
                <a href="#trivializing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7421">
                  <span className="text-gray-400" data-id="element-7422">→</span> 3. 感情を軽視する
                </a>
              </li>
              <li data-id="element-7423">
                <a href="#shifting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7424">
                  <span className="text-gray-400" data-id="element-7425">→</span> 4. 責任転嫁
                </a>
              </li>
              <li data-id="element-7426">
                <a href="#victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7427">
                  <span className="text-gray-400" data-id="element-7428">→</span> 5. 被害者を演じる
                </a>
              </li>
              <li data-id="element-7429">
                <a href="#overtime" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7430">
                  <span className="text-gray-400" data-id="element-7431">→</span> 6.
                  時間の経過に伴うガスライティング
                </a>
              </li>
              <li data-id="element-7432">
                <a href="#tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7433">
                  <span className="text-gray-400" data-id="element-7434">→</span> 7. 公的 vs
                  私的なトーンの変化
                </a>
              </li>
              <li data-id="element-7435">
                <a href="#faq" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7436">
                  <span className="text-gray-400" data-id="element-7437">→</span> よくある質問
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-7438">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-7439">
              人間関係で気が狂いそうだと感じたことはありますか？ 🚩
              パートナーはあることを言うかもしれませんが、あなたの直感は別のことを言います。それは
              <strong data-id="element-7440">ガスライティング</strong>
              と呼ばれ、あなた自身を疑わせるように設計された微妙で操作的な行動です。
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-7441">
              ほとんどの人はガスライティングの兆候を見逃しますが、当社のAIはあなたのチャットを分析して真実を明らかにすることで即座にそれを見つけます。AIが検出するガスライティングの7つの兆候をご紹介します。
            </p>

            <section id="denying" className="mb-12" data-id="element-7442">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7443">
                1️⃣ 起きたことを否定する
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7444">
                <p className="italic text-gray-700 text-lg" data-id="element-7445">
                  「そんなこと言ってない。」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7446">
                聞き覚えがありますか？ガスライターはしばしば事実や出来事を否定してあなたを混乱させます。AIは繰り返される矛盾を検出し、現実を消そうとするメッセージにフラグを立てます。
              </p>
            </section>

            <section id="twisting" className="mb-12" data-id="element-7447">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7448">
                2️⃣ 事実を歪める
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7449">
                <p className="italic text-gray-700 text-lg" data-id="element-7450">
                  「君の想像だよ。」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7451">
                この古典的な動きは、あなた自身の記憶を疑わせます。AIは、メッセージが操作されたり、疑わせるために選択的に再構成されたりしている場合にフラグを立てます。
              </p>
            </section>

            <section id="trivializing" className="mb-12" data-id="element-7452">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7453">
                3️⃣ 感情を軽視する
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7454">
                <p className="italic text-gray-700 text-lg" data-id="element-7455">
                  「敏感すぎるよ。」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7456">
                感情を最小限に抑えることは大きな危険信号です。AIは、あなたの感じ方を却下または評価を下げるトーンパターンを見つけます。
              </p>
            </section>

            <section id="shifting" className="mb-12" data-id="element-7457">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7458">
                4️⃣ 責任転嫁
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7459">
                <p className="italic text-gray-700 text-lg" data-id="element-7460">
                  「これは君のせいだ。」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7461">
                議論が常に「あなたのせい」になることに気づいたことはありますか？AIは責任を転嫁しようとする繰り返しの試みを強調するので、パターンを明確に見ることができます。
              </p>
            </section>

            <section id="victim" className="mb-12" data-id="element-7462">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7463">
                5️⃣ 被害者を演じる
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7464">
                <p className="italic text-gray-700 text-lg" data-id="element-7465">
                  「君のためにこんなにしてるのに...」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7466">
                罪悪感を抱かせることはコントロールの微妙な形態です。AIは、あなたを気分悪くさせたり過度に謝らせたりするように設計された操作的な言い回しにフラグを立てます。
              </p>
            </section>

            <section id="overtime" className="mb-12" data-id="element-7467">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7468">
                6️⃣ 時間の経過に伴うガスライティング ⏳
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7469">
                ガスライティングは常に明白ではありません。それは徐々に構築されます。AIは複数の会話にわたってパターンを追跡し、有毒な行動の全体像を提供します。
              </p>
            </section>

            <section id="tone" className="mb-12" data-id="element-7470">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7471">
                7️⃣ 公的 vs 私的なトーンの変化
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7472">
                <p className="italic text-gray-700 text-lg" data-id="element-7473">
                  グループチャット: 😊 / 1対1: 😡
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7474">
                一部のガスライターは、公の場と私的なメッセージで異なる振る舞いをします。AIは不一致を捉え、突然の気分の変化や隠された攻撃性を強調します。
              </p>
            </section>

            <section className="mb-12" data-id="element-7475">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7476">
                🛡 自分を守る方法
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-7477">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-7478">
                  <li className="flex items-start gap-3" data-id="element-7479">
                    <span className="text-purple-600 font-bold" data-id="element-7480">•</span>
                    <span data-id="element-7481">直感を信じてください。</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7482">
                    <span className="text-purple-600 font-bold" data-id="element-7483">•</span>
                    <span data-id="element-7484">会話の記録を保管してください。</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7485">
                    <span className="text-purple-600 font-bold" data-id="element-7486">•</span>
                    <span data-id="element-7487">友人やセラピストに話してください。</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7488">
                    <span className="text-purple-600 font-bold" data-id="element-7489">•</span>
                    <span data-id="element-7490">
                      最も重要なこと：危険信号を無視しないでください。
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-7491">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7492">
                💀 なぜ当社のAIが機能するのか
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7493">
                人間や一般的なチャットボットとは異なり、Toxic
                Detectorは以下を提供します：
              </p>
              <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6" data-id="element-7494">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-7495">
                  <li className="flex items-start gap-3" data-id="element-7496">
                    <span className="text-purple-600 font-bold" data-id="element-7497">•</span>
                    <span data-id="element-7498">ワンタップのスクリーンショットアップロード</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7499">
                    <span className="text-purple-600 font-bold" data-id="element-7500">•</span>
                    <span data-id="element-7501">即座に共有可能な結果</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7502">
                    <span className="text-purple-600 font-bold" data-id="element-7503">•</span>
                    <span data-id="element-7504">実際に信頼できる感情的で共感できる結果</span>
                  </li>
                </ul>
              </div>
              <p className="text-lg font-semibold text-gray-900" data-id="element-7505">
                推測するのはやめましょう。知り始めましょう。 💖
              </p>
            </section>

            <section id="faq" className="mb-12" data-id="element-7506">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7507">
                よくある質問
              </h2>
              <div className="space-y-4" data-id="element-7508">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-7509">
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-7510">
                      <span data-id="element-7511">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-7512" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-7513">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-7514">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-7515">
              💀 真実を見る準備はできましたか？
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-7516">
              ガスライティングは微妙で危険で消耗しますが、当社のAIはそれを明確にすることができます。チャットをアップロードして、即座に毒性レポートを取得してください。
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-7517">
              <p className="font-bold text-xl" data-id="element-7518">"🚩 83% 有毒。操作に注意！"</p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-7519">
              今すぐチャットをスキャン →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: '用語を学ぶ：ナルシシズムとガスライティング',
          description: 'ナルシシズムとガスライティングの操作戦術の背後にある心理学を理解する。',
          slug: 'narcissism-gaslighting-explained',
          emoji: '💀'
        }, {
          title: 'あなたの元カレは隠れナルシシストですか？',
          description: 'テキスト分析を通じて、元カレが隠れナルシシストの行動の兆候を示しているかを発見します。',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }]} data-id="element-7520" />

          <div className="mt-12 text-center" data-id="element-7521">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-7522">
              <Share2 size={18} className="mr-2" data-id="element-7523" />
              この記事を共有
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-7524">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-7525">
            <p className="text-gray-500 text-sm" data-id="element-7526">
              © {new Date().getFullYear()} ToxicDetector. 全著作権所有。
            </p>
          </div>
        </footer>
      </div>
    </div>;
}